import * as React from "react";
import "./SegmentHeader.css";

interface SegmentHeaderProps {
    children?: React.ReactNode;
}

class SegmentHeader extends React.Component<SegmentHeaderProps> {
    public render() {
        return (
            <h3 className="segment-header">{this.props.children}</h3>
        );
    }
}

export default SegmentHeader;